import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssignee = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.6001 4.53333C4.6001 5.33782 4.91968 6.10936 5.48854 6.67822C6.0574 7.24708 6.82894 7.56666 7.63343 7.56666C8.43792 7.56666 9.20946 7.24708 9.77831 6.67822C10.3472 6.10936 10.6668 5.33782 10.6668 4.53333C10.6668 3.72884 10.3472 2.9573 9.77831 2.38844C9.20946 1.81958 8.43792 1.5 7.63343 1.5C6.82894 1.5 6.0574 1.81958 5.48854 2.38844C4.91968 2.9573 4.6001 3.72884 4.6001 4.53333V4.53333Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 14.5C2 13.006 2.59351 11.5731 3.64996 10.5167C4.70642 9.46021 6.13928 8.8667 7.63333 8.8667C8.51469 8.8667 9.37475 9.07324 10.1488 9.45951",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12.5676L10.8667 14.4343L14.8667 10.4343",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAssignee;
